import CryptoJS from 'crypto-js';
import serverClientUtil from './serverClientUtil';

const ENCRYPTION_KEY = serverClientUtil.cryptoKey;

const cryptoUtil = {
  encrypt: (data) => {
    try {
      const jsonString = typeof data === 'string' ? data : JSON.stringify(data);
      const encrypted = CryptoJS.AES.encrypt(
        jsonString,
        ENCRYPTION_KEY,
      ).toString();
      return encrypted;
    } catch (error) {
      console.error('Encryption error:', error);
      return null;
    }
  },

  decrypt: (encryptedData) => {
    try {
      if (!ENCRYPTION_KEY) {
        return null;
      }
      const decrypted = CryptoJS.AES.decrypt(
        encryptedData,
        ENCRYPTION_KEY,
      ).toString(CryptoJS.enc.Utf8);
      try {
        return JSON.parse(decrypted);
      } catch {
        return decrypted;
      }
    } catch (error) {
      console.error('Decryption error:', error);
      return null;
    }
  },
};

export default cryptoUtil;
